export default __webpack_public_path__ + "static/media/settle-5.8eeffbd6.png";